import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { useAuth } from "@/context/AuthContext";
import EmployeeProfile from "@/pages/EmployeeProfile";

/**
 * Self Service entry for My Profile.
 * Reuses the admin Employee Profile page with ESS-restricted tabs
 * (see ESS_PROFILE_TAB_IDS in EmployeeProfile.jsx).
 */
export default function MyProfile() {
  const { user } = useAuth();
  const [employeeId, setEmployeeId] = useState(user?.employee_id || null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (user?.employee_id) {
      setEmployeeId(user.employee_id);
      setMissing(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const me = await api.get("/employees/me");
        if (!cancelled) {
          if (me.data?.id) setEmployeeId(me.data.id);
          else setMissing(true);
        }
      } catch {
        if (!cancelled) setMissing(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.employee_id]);

  if (missing) {
    return (
      <AdminLayout title="My Profile" breadcrumbs={["Home", "Self Service", "Profile"]}>
        <div className="text-slate-500 text-sm">No employee record is linked to your login.</div>
      </AdminLayout>
    );
  }

  if (!employeeId) {
    return (
      <AdminLayout title="My Profile" breadcrumbs={["Home", "Self Service", "Profile"]}>
        <div className="text-slate-500 text-sm">Loading…</div>
      </AdminLayout>
    );
  }

  return <EmployeeProfile employeeId={employeeId} selfService />;
}
